/**
 * Shared constants and utilities. Loaded before all other theme scripts.
 * Exposes window.BB namespace.
 */
(function () {
  'use strict';
  var BB = window.BB || {};

  BB.RESULTS_ID = 'collection-results';

  // Same format as original product-variants.js — keeps price display consistent.
  BB.formatMoney = function (cents) {
    return '$' + (cents / 100).toFixed(2);
  };

  window.BB = BB;
})();
